import Script from "next/script";

interface IProps {
  data: {
    "@id": string;
    title: string;
    description?: string;
    images?: string[];
    url?: string;
    /**CCYY-MM-DDThh:mm:ss */
    pubDate?: string;
    /**CCYY-MM-DDThh:mm:ss */
    upDate?: string;
  };
}

/**网站结构化数据 */
export default function JsonLd(props: IProps) {
  return (
    <Script
      id="json-ld"
      strategy="beforeInteractive"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonld", // 固定不变
          ...props.data,
        }),
      }}
    ></Script>
  );
}
